export default function base64Decode(value: string): string {
  return process.browser ? window.atob(value) : Buffer.from(value, "base64").toString();
}
